export default "__VITE_ASSET__D88JKw3M__"